// extracted by mini-css-extract-plugin
export default {"returnWarning":"change-account-type_returnWarning__zM+a3","pGreen":"change-account-type_pGreen__mM5eJ","pRed":"change-account-type_pRed__IeKdt"};